import {
  FeedbackBlock,
  FeedbackBlockGraphic,
  FeedbackBlockTitle,
} from '@/components/ui/feedback-block'
import { useFeatured } from '@/contexts/featured-context'
import { Feature } from '@/schemas/feature'

type FeaturedRouteProps = {
  feature: Feature
  fallback?: React.ReactNode
  children: React.ReactNode
}

export function FeaturedRoute({
  feature,
  fallback,
  children,
}: FeaturedRouteProps) {
  const { isAllowed } = useFeatured(feature)

  if (isAllowed) {
    return children
  }

  if (fallback) {
    return fallback
  }

  return (
    <FeedbackBlock>
      <FeedbackBlockGraphic />

      <FeedbackBlockTitle title="Página indisponível no momento." />
    </FeedbackBlock>
  )
}
